import { Box, Typography } from '@mui/material';
import EmptyIcon from 'components/Icons/EmptyIcon';
import React from 'react';

/**
 * A reusable component for displaying an empty state.
 *
 * @param {string} title - The title to display in the empty state.
 * @param {object} sx - The sx prop from MUI for custom styling.
 * @return {JSX.Element} The JSX element representing the empty state.
 */ const Empty = ({ title = 'Nothing to see here', sx }) => {
  return (
    <Box
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      flexDirection={'column'}
      mt={'50px'}
      sx={sx}
    >
      <EmptyIcon />
      <Typography fontWeight={600} textAlign={'center'}>
        {title}
      </Typography>
    </Box>
  );
};

export default Empty;
